import axios from "axios"
import Cookies from 'js-cookie';
import store from '../store/store';
import { getCookie } from '../utils/AEMUtils';
import { AUTH_COOKIE_STORE } from '../common/constant';

const{REACT_APP_SERVICE_URL} =window.weeksWebCloudConfig;
/**
  * @desc This function is for getting the AccessToken inorder to call any microservice
  * @return accessToken - Oauth Token for Authorization 
**/
  export const AuthStatus = async () =>{
    //let urlResolverToken = ;
    //debugger;
  const loggedIn = JSON.parse(getCookie(AUTH_COOKIE_STORE));

    let token= UrlResolver();
    if(token === "Invalid"){
      token = sessionStorage.getItem("URL_RESOLVER_TOKEN")
    }   
    else sessionStorage.setItem('URL_RESOLVER_TOKEN', token);

    store.dispatch({type:"SET_URL_RESOLVER_TOKEN", payload:token});
/*     console.log(document.cookie); */
    //getCookie("access_token");
    //getPreviewUrl();
    let tokenRes;
    const headers =  {headers: { Authorization: `Bearer ${token}`,byPassCookie:true}}
    /* try {
      //debugger;
      tokenRes = await axios.post(`${REACT_APP_SERVICE_URL}/jwt/validation`, null, headers)
      //debugger;
      return tokenRes.data;
    } catch (error) {
      //debugger;
      tokenRes = error.response.data
    }
    return tokenRes; */

    //const corsCredential = {withCredentials: true}
    if (!loggedIn) {
      if(process.env.NODE_ENV !== "development"){
        try {
            tokenRes = await axios({
            url:`${REACT_APP_SERVICE_URL}/jwt/validation`,
            method: 'post',
            withCredentials: true
            })
            const expiresIn = new Date(new Date().getTime() + tokenRes?.data.refresh_token_expires_in * 1000);
            Cookies.set(AUTH_COOKIE_STORE, tokenRes.data, { expires: expiresIn });
            //debugger;
            return tokenRes.data;
          } catch (error) {
            //debugger;
            localStorage.removeItem('loginFormMessage');
            Cookies.remove(AUTH_COOKIE_STORE);
            window.location.href = "/signout";
            //tokenRes = error.response.data
          }
          return tokenRes;
        }
        else{
        
          try {
          tokenRes = await axios({
            url:`${REACT_APP_SERVICE_URL}/validation/jwt`,
            method: 'post',
            withCredentials: true,
            /* headers: { 
            Authorization: `Bearer ${token}`,
            byPassCookie:true
            } */
            params:{
              //customerId:"199902421",
              //customerId:"C79317548",
              //customerId:"494013358",
              //customerId:"402520630",
              // customerId:"045062689",
              //customerId:"045075972",
              //customerId:"100806836",
              customerId:"571102015",
              locale: "en_US"
            }
            })
            const expiresIn = new Date(new Date().getTime() + tokenRes?.data.refresh_token_expires_in * 1000);
            Cookies.set(AUTH_COOKIE_STORE, tokenRes.data, { expires: expiresIn });
            //debugger;
            return tokenRes.data;
          }catch (error) {
            //debugger;
            //debugger;
            // window.location.href = "/signout";
            //tokenRes = error.response.data
            localStorage.removeItem('loginFormMessage');
          }
          return tokenRes;
      }
    }   
  }

/* function getCookie(tokenName) {
  var cookieArr = document.cookie.split(";");
  for(var i = 0; i < cookieArr.length; i++) {
      var cookiePair = cookieArr[i].split("=");
      if(tokenName === cookiePair[0].trim()) {
        //console.log(decodeURIComponent(cookiePair[1]));
        return decodeURIComponent(cookiePair[1]) 
      }
  }
  return "Invalid";
} */

  const UrlResolver = ()=>{
    //debugger;
    let setToken= ""
    //let getToken= ""
    let locationUrl= window.location.href;
    let tokenParam = locationUrl.split("?")[1];
    if(tokenParam !== undefined){
     // let getCustomerId = 
     setToken = tokenParam.split("=")[1];
     //getToken = setToken.split("#")[0];
    }
    else{
      setToken = "Invalid"; 
    }
   //console.log(setToken);
   return setToken;
  }


  


  

  